import React from "react";
import Div from "../../../../widget/common/ui/Div";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ConversationsTimeType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { formatTimestampIntl } from "../../../../service/date_service/date_service";

/* 
const formatTimestampIntl = (date: Date): string => {
  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const optionsDate: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  const time = new Intl.DateTimeFormat("en-US", optionsTime).format(date);
  const day = new Intl.DateTimeFormat("en-US", optionsDate).format(date);

  return `${time} • ${day}`; // "02:30 PM • 29 Apr 2024"
}; */

const ConversationTime: React.FC<ConversationsTimeType> = ({
  isUser,
  createDate,
  readStatus,
  deliveredStatus,
  flag,
}) => {
  const type: number = ResponsiveDeviceType();

  return (
    <Div
      className="group-time justify-content-end pt-1"
      fontName="book"
      fontSize="8"
      color="black"
    >
      {createDate != null && (
        <span>{formatTimestampIntl(new Date(createDate!))}</span>
      )}

      {isUser && (
        <IconNormal
          name={
            deliveredStatus === "0" && readStatus === "0"
              ? "chat_deliver"
              : "chat_read"
          }
          color={readStatus === "1" ? AppTheme.green3 : AppTheme.black}
          size={type === 3 ? 18 : 15}
        />
      )}
    </Div>
  );
};

export default ConversationTime;

/* 
 @override
  Widget build(BuildContext context) {
    return Consumer<ChatProvider>(
      builder: (_, mainPro, __) {
        return Consumer<GroupChatProvider>(
          builder: (_, groupPro, __) {
            return Consumer<TeamChatProvider>(
              builder: (_, teamPro, __) {
                return Consumer<DepartmentChatProvider>(
                  builder: (_, depPro, __) {
                    return Align(
                      alignment: Alignment.centerRight,
                      child: Row(
                        mainAxisSize: MainAxisSize.min,
                        mainAxisAlignment: MainAxisAlignment.center,
                        children: [
                          MySpacing.width(30),
                          Text(
                            formatTimestamp(
                              mainPro.chatFlag === "3"
                                  ? groupPro.messages[index].createDate!
                                  : mainPro.chatFlag === "2"
                                  ? depPro.messages[index].createDate!
                                  : teamPro.messages[index].createDate!,
                            ),
                            style: Styles().style(
                              type: type,
                              textType: MyTextType.size_8,
                              fontType: MyFontType.book,
                              color: colorChange
                                  ? Colours().bg
                                  : Colours().black,
                            ),
                          ),
                          MySpacing.width(isUser ? 3.98 : 0),
                          isUser
                              ? SizedBox(
                                  height: type === 3 ? 18 : 15,
                                  width: type === 3 ? 18 : 15,
                                  child: SvgPicture.asset(
                                    "assets/icons/${(mainPro.chatFlag === "3"
                                                    ? "0"
                                                    : mainPro.chatFlag === "2"
                                                    ? depPro.messages[index].deliveredStatus!
                                                    : teamPro.messages[index].deliveredStatus!) === "0" && (mainPro.chatFlag === "3"
                                                    ? "0"
                                                    : mainPro.chatFlag === "2"
                                                    ? depPro.messages[index].readStatus!
                                                    : teamPro.messages[index].readStatus!) === "0" ? "chat_deliver" : "chat_read"}.svg",
                                    color:
                                        (mainPro.chatFlag === "3"
                                                ? "0"
                                                : mainPro.chatFlag === "2"
                                                ? depPro
                                                      .messages[index]
                                                      .readStatus!
                                                : teamPro
                                                      .messages[index]
                                                      .readStatus!) ==
                                            "1"
                                        ? Colours().green3
                                        : colorChange
                                        ? Colours().bg
                                        : Colours().black,
                                  ),
                                )
                              : Container(),
                          MySpacing.width(colorChange ? 3 : 0),
                        ],
                      ),
                    );
                  },
                );
              },
            );
          },
        );
      },
    );
  }
}
 */
